// extracted by mini-css-extract-plugin
module.exports = {"medium":"index-module--medium--8ZJgz","facebook":"index-module--facebook--3EsNs","twitter":"index-module--twitter--2TMft","large":"index-module--large--1dHmM"};